// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__0eD6F","overlay":"Modal_overlay__7QTFZ","inner":"Modal_inner__Ek7uv","modalIn":"Modal_modalIn__bsS9e","close-btn":"Modal_close-btn__5eSD9"};